import { FormSkeleton, RegionCargando, Skeleton } from "@/components/ui";

/**
 * Diseñador de flujo en carga · mismo marco que `DisenadorFlujoPage` (alto de la
 * ventana, barra superior y las 3 columnas: paleta 260px · lienzo · propiedades
 * 380px). `pendingComponent` de `/admin/notificaciones/$id`.
 */
export function DisenadorFlujoSkeleton() {
  return (
    <RegionCargando
      etiqueta="Cargando diseñador…"
      className="flex h-[calc(100dvh-var(--shell-header-h)-2*var(--shell-padding))] flex-col overflow-hidden rounded-lg border border-border bg-card"
    >
      <div className="flex items-center gap-3 border-b border-border px-4 py-2.5" aria-hidden="true">
        <Skeleton height={32} width={32} />
        <div className="flex flex-col gap-1.5">
          <Skeleton height={14} width={220} />
          <Skeleton height={10} width={140} />
        </div>
        <div className="ml-auto flex gap-2">
          <Skeleton height={32} width={96} />
          <Skeleton height={32} width={110} />
          <Skeleton height={32} width={100} />
        </div>
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-[260px_1fr_380px]" aria-hidden="true">
        <aside className="flex flex-col gap-3 border-r border-border p-3">
          <Skeleton height={32} />
          {Array.from({ length: 8 }, (_, i) => (
            <Skeleton key={i} height={34} width={i % 3 === 0 ? "90%" : "100%"} />
          ))}
        </aside>
        <div className="relative bg-muted/30">
          <Skeleton height={56} width={200} className="absolute left-[12%] top-[20%]" />
          <Skeleton height={56} width={200} className="absolute left-[45%] top-[14%]" />
          <Skeleton height={56} width={200} className="absolute left-[45%] top-[42%]" />
        </div>
        <aside className="border-l border-border p-4">
          <Skeleton height={16} width="45%" className="mb-4" />
          <FormSkeleton campos={5} columnas={1} />
        </aside>
      </div>
    </RegionCargando>
  );
}
